import { Context, createContext } from 'react';

import { PersistGateContextData } from '../interfaces';

export const PersistGateContext: Context<PersistGateContextData> = createContext<PersistGateContextData>({
  websocketDomain: null,
});
